import React, { useState, useRef, useCallback } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Form, {
  Item,
  Label,
  ButtonItem,
  ButtonOptions,
  RequiredRule,
  EmailRule
} from 'devextreme-react/form';
import LoadIndicator from 'devextreme-react/load-indicator';
import notify from 'devextreme/ui/notify';
import { useAuth } from '../../contexts/auth';

import './LoginForm.scss';
import header from '../../images/header.png';
import GlobalParams from '../../helpers/GlobalParams';
import axios from 'axios';
import { LoadPanel, Popup } from 'devextreme-react';
import NewQuotation from '../../pages/NewQuotation/NewQuotation';
import Members from '../../pages/members/members';

export default function LoginForm() {
  localStorage.clear();
  const navigate = useNavigate();
  const { signIn } = useAuth();
  const [popupPOPFundVisible, setPopupPOPFundVisible] = useState(false);
  const [isLoadingParams, setIsLoadingParams] = useState(false);
  const [loading, setLoading] = useState(false);
  const [vsClientSelected, setVsClientSelected] = useState(false);
  const [vsBrokerOption, setVsBrokerOption] = useState(true);
  const [vsClientOption, setVsClientOption] = useState(true);
  const formData = useRef({ email: '', password: '', is_group_client_contact_person: 0 });

  const [popupQuoteVisible, setPopupQuotationVisible] = useState(false);
  const hideQuotePopup = () => {
    setPopupQuotationVisible(false);
  };

  const onSubmit = useCallback(async (e) => {
    e.preventDefault();
    const { email, password } = formData.current;
    setLoading(true);

    let is_group_client_contact_person = 0;
    if (GlobalParams.IsClientLoggedIn) {
      is_group_client_contact_person = 1;
    }

    const result = await signIn(email, password, is_group_client_contact_person); // Pass is_group_client_contact_person as an argument
    if (!result.isOk) {
      setLoading(false);
      notify(result.message, 'error', 2000);
    }
  }, [signIn]);

  const onCreateAccountClick = useCallback(() => {
    navigate('/create-account');
  }, [navigate]);

  const hidePOPFundPopup = (e) => {
    setPopupPOPFundVisible(false);
  }

  return (
    <div>
      <div>
        <h1 style={{ color: 'red', fontWeight: 'bold', fontSize: '1.8rem' }}>Group Business</h1>
      </div>
      {isLoadingParams && <LoadPanel visible={true} />}
      <div>
        {popupPOPFundVisible && <Popup
          visible={popupPOPFundVisible}
          onHiding={hidePOPFundPopup}
          title=""
        >
          <Members />
        </Popup>}
      </div>
      <div>
        <Popup
          visible={popupQuoteVisible}
          onHiding={hideQuotePopup}
          title="REQUEST A NEW QUOTATION"

        >
          <NewQuotation onClosePopup={hideQuotePopup} />
        </Popup>
      </div>
      <form className={'login-form'} onSubmit={onSubmit}>
        <Form
          formData={formData.current}
          disabled={loading}
          colCount={2}
        >
          <ButtonItem
            colSpan={2}
            visible={true}
          >
            <ButtonOptions
              text={'DAS / Welfare Schemes'}
              width={'100%'}
              onClick={async () => {
                setIsLoadingParams(true);
                await GlobalParams.fetchParams({
                  param: 'get-banks',
                  property: 'Banks',
                });
                await GlobalParams.fetchParams({
                  param: 'get-bank-branches-codes',
                  property: 'BankBranches',
                });
                await GlobalParams.fetchParams({
                  param: 'contact-allowed-person-schemes?contact_person_id=0&is_pop_fund=1',
                  property: 'schemeStore',
                });

                await GlobalParams.fetchParams({
                  param: 'get-loan-types',
                  property: 'LoanTypes',
                });

                if (GlobalParams.schemeStore.length === 1) {
                  GlobalParams.defaultSchemeId = GlobalParams.schemeStore[0]["schemeID"];

                  // //schemeCategoriesStore
                  // await GlobalParams.fetchParams({
                  //   param: 'scheme-categories?scheme_id=' + GlobalParams.defaultSchemeId,
                  //   property: 'schemeCategoriesStore',
                  // });
                }
                setIsLoadingParams(false);
                setPopupPOPFundVisible(true);
                /*setIsLoadingParams(true);
                //fetch params first b4 opening the pop up
                await GlobalParams.fetchParams({
                  param: 'product-classes',
                  property: 'ProductClasses',
                });

                //Group, Welfare & Travel
                GlobalParams.QuoteProductClasses = GlobalParams.ProductClasses.filter
                  (glclass => (
                    (
                      glclass.ShowInPortal === "1") &&
                    glclass.IsActive === "1"
                  )
                  );

                await GlobalParams.fetchParams({
                  param: 'product-rider-classes',
                  property: 'ProductRider',
                });

                await GlobalParams.fetchParams({
                  param: 'product-packages-classes',
                  property: 'ProductPackages',
                });

                await GlobalParams.fetchParams({
                  param: 'scheme-riders',
                  property: 'AllRiders',
                });
                setIsLoadingParams(false);
                setPopupQuotationVisible(true);*/
              }}
            />
          </ButtonItem>
          <ButtonItem
            colSpan={2}
            visible={true}
          >
            <ButtonOptions
              text={'Interested in a Quote?'}
              width={'100%'}
              onClick={async () => {
                localStorage.clear();
                setIsLoadingParams(true);
                //fetch params first b4 opening the pop up
                await GlobalParams.fetchParams({
                  param: 'product-classes',
                  property: 'ProductClasses',
                });

                //Group, Welfare & Travel
                GlobalParams.QuoteProductClasses = GlobalParams.ProductClasses.filter
                  (glclass => (
                    (
                      glclass.ShowInPortal === "1") &&
                    glclass.IsActive === "1"
                  )
                  );

                await GlobalParams.fetchParams({
                  param: 'product-rider-classes',
                  property: 'ProductRider',
                });

                await GlobalParams.fetchParams({
                  param: 'product-packages-classes',
                  property: 'ProductPackages',
                });

                await GlobalParams.fetchParams({
                  param: 'scheme-riders',
                  property: 'AllRiders',
                });
                setIsLoadingParams(false);
                setPopupQuotationVisible(true);
              }}
            />
          </ButtonItem>
          <Item
            colSpan={2}
            visible={vsClientOption}
            dataField={'isClient'}
            editorType={'dxCheckBox'}
            editorOptions={{
              text: 'LOGIN AS CLIENT',
              elementAttr: { class: 'form-text' },
              onValueChanged: (e) => {
                setVsClientSelected(true);
                if (e.value === true) {
                  GlobalParams.IsClientLoggedIn = true;
                  setVsBrokerOption(false);
                } else {
                  setVsBrokerOption(true);
                }
                if (e.value === false && vsClientSelected === true) {
                  setVsClientSelected(false);
                }
              }
            }}
          >
            <Label visible={false} />
          </Item>
          <Item
            colSpan={2}
            visible={vsBrokerOption}
            dataField={'isBroker'}
            editorType={'dxCheckBox'}
            editorOptions={{
              text: 'LOGIN AS BROKER',
              elementAttr: { class: 'form-text' },
              onValueChanged: (e) => {
                setVsClientSelected(true);
                if (e.value === true) {
                  setVsClientOption(false);
                  GlobalParams.IsClientLoggedIn = false;
                } else {
                  setVsClientOption(true);
                }

                if (e.value === false && vsClientSelected === true) {
                  setVsClientSelected(false);
                }
              }
            }}
          >
            <Label visible={false} />
          </Item>
          <Item
            colSpan={2}
            visible={vsClientSelected}
            dataField={'email'}
            editorType={'dxTextBox'}
            editorOptions={emailEditorOptions}
          >
            <RequiredRule message="Email is required" />
            <EmailRule message="Email is invalid" />
            <Label visible={false} />
          </Item>
          <Item
            colSpan={2}
            visible={vsClientSelected}
            dataField={'password'}
            editorType={'dxTextBox'}
            editorOptions={passwordEditorOptions}
          >
            <RequiredRule message="Password is required" />
            <Label visible={false} />
          </Item>
          {/* <Item
            dataField={'rememberMe'}
            editorType={'dxCheckBox'}
            editorOptions={rememberMeEditorOptions}
          >
            <Label visible={false} />
          </Item> */}

          <ButtonItem
            colSpan={2}
            visible={vsClientSelected}
          >
            <ButtonOptions
              width={'100%'}
              type={'danger'}
              useSubmitBehavior={vsClientSelected}
            >
              <span className="dx-button-text">
                {
                  loading
                    ? <LoadIndicator width={'24px'} height={'24px'} visible={true} />
                    : 'Sign In'
                }
              </span>
            </ButtonOptions>
          </ButtonItem>
          <Item
            colSpan={2}
            visible={vsClientSelected}
          >
            <div className={'link'}>
              <Link to={'/reset-password'}>Forgot password?</Link>
            </div>
          </Item>
          <ButtonItem
            colSpan={2}
            visible={true}
          >
            <ButtonOptions
              text={'Create an account'}
              width={'100%'}
              onClick={onCreateAccountClick}
            />
          </ButtonItem>
        </Form>
      </form>
    </div>
  );
}

const emailEditorOptions = { stylingMode: 'filled', placeholder: 'Email', mode: 'email' };
const passwordEditorOptions = { stylingMode: 'filled', placeholder: 'Password', mode: 'password' };
const rememberMeEditorOptions = { text: 'Remember me', elementAttr: { class: 'form-text' } };


const brokerEditorOptions = { text: 'LOGIN AS BROKER', elementAttr: { class: 'form-text' } };
